module.exports = __webpack_public_path__ + "static/pagelang-333cc1d4039ef5015b65e3b84a159762.png";